import { Component, Input, OnInit } from '@angular/core';
import { NoteSection } from 'src/app/model/section/note-section';

@Component({
  selector: 'app-revision-notices-note-section',
  templateUrl: './revision-notices-note-section.component.html',
  styleUrls: ['./revision-notices-note-section.component.scss']
})
export class RevisionNoticesNoteSectionComponent implements OnInit {
  @Input() noteSections: NoteSection[] = [];
  constructor() {}

  ngOnInit(): void {}
}
